import { UseMedia } from "hooks/useMedia";
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Birds from "../../components/Birds";
import { Accordion } from "../../components/FAQ/faq.jsx";
import Footer from "../../components/Footer/footer.jsx";
import {
  Logo,
  LogoSectionAbout,
} from "../../components/logo-section/logoSection.jsx";
import Media from "../../components/media/media.jsx";
import {
  FirstPrize,
  PrizeHeading,
} from "../../components/prize tracks/prizes.jsx";
import {
  Sponsor,
  SponsorsHead,
  SponsorUS,
} from "../../components/Sponsors/sponsors.jsx";
import { JoinTeam, Member } from "../../components/team/team";
import { Myinfo } from "../../components/Top-division-components/Top-division-components.jsx";
import {
  FOOTER,
  frequentlyAskedQuestions,
  JudgesInfo,
  Prizeinfo,
  Awardinfo,
  sponsorLogos,
  /*TeamInfo*/
  TOP_SECTION,
} from "../../Module/General";
import MyCalender from "../calender";
import "./about.css";
import pattern from "./pattern4.png";

function SponsorGroup(props) {
  return (
    <Row>
      {props.map((s) => (
        <Col className="" sm={12} lg={4} md={6}>
          {" "}
          <Sponsor srcx={s.src} link={s.link} />
        </Col>
      ))}
    </Row>
  );
}

// javascript Map for sponsors end

// Prize group

function AwardGroup(props) {
  return (
    <Row>
      {props.map((s) => (
        <Col className="" sm={12} lg={4} md={6}>
          <FirstPrize icon={s.icon} type={s.type} content={s.content} />
        </Col>
      ))}
    </Row>
  );
}

function PrizeGroup(props) {
  return (
    <Row>
      {props.map((s) => (
        <Col className="" sm={12} lg={4} md={6}>
          <FirstPrize icon={s.icon} type={s.type} content={s.content} />
        </Col>
      ))}
    </Row>
  );
}

// Prize group ending
function TeamMembers(props) {
  return (
    <Row className="members">
      {props.map((s) => (
        <Col className="" sm={12} lg={4} md={4}>
          <Member info={s} />
        </Col>
      ))}
    </Row>
  );
}

function FrequentlyAsked(props) {
  return (
    <Row className="sf">
      {props.map((s) => (
        <Col className="" sm={12} lg={6} md={6}>
          <Accordion panels={s} />
        </Col>
      ))}
    </Row>
  );
}

export default function HomePage() {
  const [media, setMedia] = useState();
  UseMedia("min-width", 1000, setMedia);

  return (
    <div className="Whole_div" style={{ backgroundImage: `url(${pattern})` }}>
      <div className="color_sectiom" id="home">
        <Container fluid>
          <Row className="Row info">
            <Col className="info-div" sm={12} lg={7} md={7}>
              <Myinfo />
            </Col>
            <Col className="d-image" sm={12} lg={5} md={5}>
              <MyCalender />
            </Col>
          </Row>

          <Row className="mediaInfo">
            <Col className="" sm={12} lg={12} md={12}>
              <Media />
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid>
        {/* Logo section  */}
        <Row className=" logoSection">
          <Col className="info-div" sm={12} lg={8} md={8}>
            <LogoSectionAbout />
          </Col>
          <Col className="info-div" sm={12} lg={4} md={4}>
            <Logo />
          </Col>
        </Row>

        {/* ********Frequently asked Questions here ***** */}
        <div className="Myfaqs" id="faq">
          {frequentlyAskedQuestions.map(FrequentlyAsked)}
          {/* ********Frequently asked Questions ending here ***** */}
        </div>

        {/* Medals */}
        <div>
          <Row className="prizesection" id="prizes">
            <PrizeHeading type="Awards" />
            {Awardinfo.map(AwardGroup)}
          </Row>
        </div>

        {/* Prizes */}
        <div>
          <Row className="prizesection" id="prizes">
            <PrizeHeading type="Bounties" />
            {Prizeinfo.map(PrizeGroup)}
          </Row>
        </div>

        {/* ********Sponsors here ***** */}
        <div>
          <Row className="sponsorSection" id="sponsors">
            <SponsorsHead />
            {/* <SponsorUS /> */}
            {sponsorLogos.map(SponsorGroup)}
            {/* <div className="Sponsor " onClick={handleClick}>
              <img src={sponsorLogos[0]} alt="Sui Foundation" />
            </div> */}
          </Row>
        </div>
        {/* ********Sponsors ending here ***** */}

        {media && <Birds top="120vh" left="0vh" type="" />}

        {/* ********Team here ***** */}
        {/*<h1 id="team">Our Team</h1>
        {FOOTER.JOIN_TEAM.required && (
          <JoinTeam
            placeholder="Join our team"
            formLink={FOOTER.JOIN_TEAM}
            content="Interested in joining our team"
          />
        )}
        {TeamInfo.map(TeamMembers)}
        {/* ********Team ending here ***** */}

        {/* ********Judges here ***** */}

        <h1 id="team">Judges</h1>
        {/* {FOOTER.JOIN_TEAM.required && (
          <JoinTeam
            placeholder="Join our team"
            formLink={TOP_SECTION.JUDGES_FORM_LINK}
            content="Interested in being judge"
          />
        )} */}
        {JudgesInfo.map(TeamMembers)}
        {/* ********Team ending here ***** */}
      </Container>
      <Footer />
    </div>
  );
}
